import React,{useContext} from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { LoaderContext } from "../../context/LoaderContext";

export default function BackdropLoader() {
  const { isLoading } = useContext(LoaderContext);
  return (
    <Backdrop
      sx={(theme) => ({
        color: "#fff",
        zIndex: 1000 + theme.zIndex.modal,
      })}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
